const getUpgradePlansDictionary = function (data) {
  const upgradePlansDictionary = {
    trademo_intel_us_free: {
      name: "Free",
      key: "trademo_intel_us_free",
      upgradeMessageArrivalDate: "You have access to only historical data. To access complete data. ",
      upgradeMessageEmailAlert: "Never miss out on tracking important shipments.",
      upgradeMessageXlsDownload: "A small investment can unlock this great feature.",
      upgradeMessageLiveNotification: "You have access to historical data. To access complete data. ",
      dashboardUpgradeMessageEmailAlert: "Never miss out on tracking important shipments.",
      planFeatures: [
        "Access to US Imports Bill of Lading Data (Jan-Mar 2018)",
        "Unlimited Search of Companies' Profile",
        "Search by Product Keywords, Buyer, Supplier Name",
        "Add to prospect list of Importers and Exporters",
        "Explore detailed functionality of Trademo Intel",
      ],
    },
    trademo_intel_us_basic: {
      name: "Basic",
      key: "trademo_intel_us_basic",
      upgradeMessageArrivalDate: "You have access to only last 6 months data. To access complete data.",
      upgradeMessageEmailAlert: "Wow! You have used 3 alerts under this plan. To set more alerts.",
      upgradeMessageXlsDownload: "You have exceeded downloadable limit under this plan. To download more. ",
      upgradeMessageLiveNotification: "Great! You have used more than 90% of your download limit in the current plan.",
      dashboardUpgradeMessageEmailAlert: "To set up more email alerts.",
      planFeatures: [
        "Last 6 months of US CBP Imports data from the date of search",
        "Upto 1,000 shipment downloads per month",
        "Set up to 3 unique email alerts",
        "All HS Codes Global Product Macro Trends",
        "Bookmark potential importer and exporter profiles",
        "Our customer success managers are available to support you with queries.",
      ],
    },
    trademo_intel_us_essential: {
      name: "Essential",
      key: "trademo_intel_us_essential",
      upgradeMessageArrivalDate: "You have access to only last 3 months data. To access complete data.",
      upgradeMessageEmailAlert: "Wow! You have used 5 alerts under this plan. To set more alerts.",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments. To download these shipments - Please upgrade.",
      upgradeMessageLiveNotification: "Great! You have used more than 90% of your download limit in the current plan.",
      dashboardUpgradeMessageEmailAlert: "To set up more email alerts.",
      planFeatures: [
        "Last 3 months of US CBP Imports data from the date of search",
        "Up to 1000 unique Bill of lading per month",
        "Set up to 5 unique email alerts",
        "Unlimited Searches",
        "Bookmark potential importer and exporter profiles",
        "Our customer success managers are available to support you with queries.",
      ],
    },
    trademo_intel_us_plus: {
      name: "Plus",
      key: "trademo_intel_us_plus",
      upgradeMessageArrivalDate: "You have access to only 12 months data. To access complete data. ",
      upgradeMessageEmailAlert: "Wow! You have used 10 alerts under this plan. To set more alerts. ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments. To download these shipments - Please upgrade.",
      upgradeMessageLiveNotification: "Great! You have used more than 90% of your download limit in the current plan.",
      dashboardUpgradeMessageEmailAlert: "To set up more email alerts.",
      planFeatures: [
        "Last 12 months of US CBP Imports data from the date of search",
        "Upto 10,000 shipment downloads per month",
        "Set up to 5 unique email alerts",
        "Unlimited Searches",
        "Bookmark potential importer and exporter profiles",
        "Our customer success managers are available to support you with queries.",
      ],
    },
    trademo_intel_us_pro: {
      name: "Pro",
      key: "trademo_intel_us_pro",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent US Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent US Shipments. ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent US Shipments. ",
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: [
        "US CBP Imports data since Jan 2018",
        "Upto 20,000 shipment downloads per month",
        "Set up to 10 unique email alerts",
        "Unlimited Searches",
        "Bookmark potential importer and exporter profiles",
        "Our customer success managers are available to support you with queries.",
      ],
    },
    trademo_intel_us_starter: {
      name: "Starter",
      key: "trademo_intel_us_starter",
      upgradeMessageArrivalDate: "You have access to last 3 months of trade data. To access complete data. ",
      planFeatures: [
        "Shipment data for last 3 months",
        "25 searches per day (Free trial - 15 searches per day)",
        "1,000 shipments download per month (Free trial - 50 downloads)",
        "Our customer success managers are available to support you with queries",
      ],
    },
    trademo_intel_us_pro2: {
      name: "Pro Plan",
      key: "trademo_intel_us_pro2",
      upgradeMessageArrivalDate: "You have access last 12 months of trade data. To access complete data. ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      planFeatures: [
        "Last 12 months shipments data(updated daily)",
        "Unlimited searches per day",
        "120,000 shipment downloads per user annually",
        "1,000 employee level contact downloads per user annually",
        "Estimated HS Code, TEUs and Shipment Value",
        "3.5 million+ Buyer/ Supplier Profiles with consolidated shipments",
        "Bookmark potential importer and exporter profiles",
      ],
    },
    trademo_intel_us_pro_lite: {
      name: "Pro Lite Plan",
      key: "trademo_intel_us_pro_lite",
      upgradeMessageArrivalDate: "You have access last 12 months of trade data. To access complete data. ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      planFeatures: [
        "Last 12 months shipments data(updated daily)",
        "Unlimited searches per day",
        "120,000 shipment downloads per user annually",
        "1,000 employee level contact downloads per user annually",
        "Estimated HS Code, TEUs and Shipment Value",
        "3.5 million+ Buyer/ Supplier Profiles with consolidated shipments",
        "Bookmark potential importer and exporter profiles",
      ],
    },
    trademo_intel_us_advanced: {
      name: "Advanced Plan",
      key: "trademo_intel_us_advanced",
      upgradeMessageArrivalDate: "You have access to only historical data. To access complete data. ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      planFeatures: [
        "Last 24 months shipments data (updated daily)",
        "US Census Data based Product Trends for last 24 months",
        "300,000 shipment downloads per user annually",
        "1000 employee level contact downloads per user annually",
        "Estimated HS Code, TEUs and Shipment Value",
        "Analytics & Insights on Search Results",
        "3.5 million+ Buyer/ Supplier Profiles with consolidated shipments",
        "Bookmark potential importer and exporter profiles",
      ],
    },
    trademo_intel_us_enterprise: {
      name: "Enterprise Plan",
      key: "trademo_intel_us_enterprise",
      upgradeMessageArrivalDate: "You have access to only historical data. To access complete data. ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      planFeatures: [
        "Jan 2014 - Present shipments data (updated daily)",
        "US Census Data based Product Trends starting Jan 2013",
        "Unlimited downloads with 10K downloads at a time per user",
        "1000 employee level contact downloads per user annually",
        "Estimated HS Code, TEUs and Shipment Value",
        "Analytics & Insights on Search Results",
        "3.5 million+ Buyer/ Supplier Profiles with consolidated shipments",
        "Bookmark potential importer and exporter profiles",
      ],
    },
  };
  return upgradePlansDictionary;
};
exports.getUpgradePlansDictionary = getUpgradePlansDictionary;
